import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../../common/widgets/Button';
import { resources } from '../../../../resources/resources';
import { ChangePasswordDialog } from './ChangePasswordDialog';

export const MyAccountChangePassword = () => {
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const { t: translate } = useTranslation();

  return (
    <>
      <p className="m-changepass-copy">
        {translate(resources.accounts.myAccount.changePassword.info)}
      </p>
      <div className="m-panel-actions-bottom">
        <Button className="btn btn-solid" onClick={() => setShowDialog(true)}>
          <span className="btn-text">
            {translate(resources.accounts.myAccount.changePassword.button)}
          </span>
        </Button>
      </div>
      {showDialog && (
        <ChangePasswordDialog closeDialog={() => setShowDialog(false)} />
      )}
    </>
  );
};
